module.exports = __webpack_public_path__ + "static/media/rintagi-square.9735b834.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/rintagi-square.png
// module id = 501
// module chunks = 0